import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-link',
    templateUrl: './link.component.html',
    styleUrl: './link.component.scss',
    standalone: true,
    imports: [CommonModule],
})
export class LinkComponent {
    @Input() isDocument = false
    @Input() size: 'small' | 'medium' | 'large' = 'medium'
    @Input('class') customClass: string = ''
    @Input('contentClass') contentClass: string = ''
    @Input() href?: string
    @Input() gtmLabel?: string;
    @Output() onClick = new EventEmitter<boolean>()

    handleClick() {
        this.onClick.emit(true)
    }

    get wrapperClasses(): string[] {
        return ['cosentino-link', 'inline-flex', 'w-full', this.customClass]
    }

    get contentClasses(): string[] {
        return ['text-center', 'select-none', 'cursor-pointer', 'items-center',this.contentClass]
    }

    get textClasses(): string[] {
        const classes = []

        switch (this.size) {
            case 'small':
                classes.push('typography-body-s-regular')
                break
            case 'medium':
                classes.push('typography-body-m-regular')
                break
            case 'large':
                classes.push('typography-body-l-regular')
                break
            default:
                classes.push('typography-body-m-regular')
                break
        }

        return classes
    }
}
